import {
  Button,
  Form,
  InputNumber,
  notification,
  Popconfirm,
  Space,
  Tooltip,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StreamService } from "../../../services/streamService";
import { useRef } from "react";
import {
  CarryOutOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import authAxios from "../../../services/api";
import TokenService from "../../../services/token.service";
import { FinalAssessmentService } from "../../../services/FinalAssessmentService";

const OperationRowOnEdit = (
  edit,
  editFinalGrade,
  save,
  cancel,
  currentRecord
) => {
  return {
    title: "Действие",
    dataIndex: "operation",
    fixed: "right",
    render: (_, record) => {
      return (
        <Space>
          <Button type="primary" disabled onClick={() => edit(currentRecord)}>
            <EditOutlined />
          </Button>
          <Tooltip title="Итоговая оценка">
            <Button
              type="primary"
              disabled
              onClick={() => editFinalGrade(currentRecord)}
            >
              <CarryOutOutlined />
            </Button>
          </Tooltip>
          <Typography.Link onClick={() => save(currentRecord)}>
            <Button type="primary">
              <SaveOutlined />
            </Button>
          </Typography.Link>
          <Popconfirm
            title="Вы точно хотите отменить это действие?"
            onConfirm={cancel}
          >
            <Button>Отмена</Button>
          </Popconfirm>
        </Space>
      );
    },
    width: 50,
  };
};

const OperationRow = (edit, editFinalGrade, save, cancel) => {
  return {
    title: "Действие",
    dataIndex: "operation",
    fixed: "right",
    render: (_, record) => {
      return (
        <Space>
          <Tooltip title="Добавить оценку">
            <Button type="primary" onClick={() => edit(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Итоговая оценка">
            <Button type="primary" onClick={() => editFinalGrade(record)}>
              <CarryOutOutlined />
            </Button>
          </Tooltip>
          <Typography.Link onClick={() => save(record)}>
            <Button type="primary" disabled>
              <SaveOutlined />
            </Button>
          </Typography.Link>
          <Popconfirm
            title="Вы точно хотите отменить это действие?"
            onConfirm={cancel}
          >
            <Button disabled>Отмена</Button>
          </Popconfirm>
        </Space>
      );
    },
    width: 50,
  };
};

// const FinalGradeRowOnEdit = (saveFinalGrade, cancelFinalGradeEdit) => {
//   return {
//     title: "Итоговая оценка",
//     dataIndex: "finalGrade",
//     fixed: "right",
//     render: (_, record) => {
//       return (
//         <Space>
//           <Form.Item
//             name="finalGrade"
//             style={{
//               margin: 0,
//             }}
//           >
//             <InputNumber min={0} max={100} />
//           </Form.Item>
//           <Button
//             type="primary"
//             icon={<CheckOutlined />}
//             onClick={() => saveFinalGrade(record)}
//           ></Button>
//           <Button
//             type="danger"
//             icon={<CloseOutlined />}
//             onClick={cancelFinalGradeEdit}
//           ></Button>
//         </Space>
//       );
//     },
//     width: 50,
//   };
// };

// const FinalGradeRow = (grade) => {
//   return {
//     title: "Итоговая оценка",
//     dataIndex: "finalGrade",
//     fixed: "right",
//     render: (_, record) => {
//       return (
//         <Space>
//           <Typography.Text
//             type={grade > 50 ? "success" : "danger"}
//           ></Typography.Text>
//         </Space>
//       );
//     },
//     width: 50,
//   };
// };

export default function useAssessmentsPage() {
  const [form] = Form.useForm();
  const { teacherId, streamId } = useParams();
  const lessons = useRef([]);
  const studentsData = useRef([]);

  const [filteredStudentsData, setFilteredStudentsData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentFinalAssessmentStudent, setCurrentFinalAssessmentStudent] =
    useState(null);
  const [hasGrade, setHasGrade] = useState(false);
  const [columns, setColumns] = useState([
    {
      title: "Студент",
      dataIndex: "student",
      key: "student",
      sorter: (a, b) => a.student.localeCompare(b.student),
      width: 250,
      fixed: true,
    },
  ]);
  const isEditing = (record) => record.key === editingKey;
  const [isFinalAssessmentModalOpen, setIsFinalAssessmentModalOpen] =
    useState(false);
  const [isExamAssessmentModalOpen, setIsExamAssessmentModalOpen] =
    useState(false);
    const [isFinalExamAssessmentModalOpen, setIsFinalExamAssessmentModalOpen] =
    useState(false);
  const [finalAssessmentData, setFinalAssessmentData] = useState([]);
  const [examAssessmentData, setExamAssessmentData] = useState([]);
  const [finalExamAssessmentData, setFinalExamAssessmentData] = useState([]);

  const deleteFinalAssessment = (assessmentId) => {
    setLoading(true);
    FinalAssessmentService.deleteFinalAssessmentByAssessmentId(assessmentId)
      .then(() => notification.success({ message: "Оценка удалена." }))
      .catch((e) =>
        notification.error({
          message: "Не удалось удалить оценку.",
          description: e.message,
        })
      )
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
        setHasGrade(false);
      });
  };

  const updateFinalAssessment = (assessmentId, requestBody) => {
    setLoading(true);
    FinalAssessmentService.updateFinalAssessment(assessmentId, requestBody)
      .then(() =>
        notification.success({ message: "Итоговая оценка изменена!" })
      )
      .catch((e) =>
        notification.error({
          message: "Возникла ошибка.",
          description: e.message,
        })
      )
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
        setHasGrade(false);
      });
  };

  const createFinalAssessment = (requestBody) => {
    FinalAssessmentService.createFinalAssessment(requestBody)
      .then(() =>
        notification.success({ message: "Итоговая оценка поставлена!" })
      )
      .catch((e) =>
        notification.error({
          message: "Не удалось добавить оценку.",
          description: e.message,
        })
      )
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
        setHasGrade(false);
      });
  };

  const handleChangeFinalAssessment = () => {
    console.log(currentFinalAssessmentStudent);

    const requestBody = {
      assessment: currentFinalAssessmentStudent.assessment,
      student: currentFinalAssessmentStudent.studentId,
      academicStream: streamId,
    };
    if (currentFinalAssessmentStudent.assessment === null) {
      deleteFinalAssessment(currentFinalAssessmentStudent.assessmentId);
      return;
    }
    if (hasGrade) {
      updateFinalAssessment(
        currentFinalAssessmentStudent.assessmentId,
        requestBody
      );
      return;
    }

    createFinalAssessment(requestBody);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setHasGrade(false);
    setCurrentFinalAssessmentStudent(null);
  };

  const openFinalAssessmentModal = () => {
    setIsFinalAssessmentModalOpen(true);
    setLoading(true);
    setFinalAssessmentData([]);
    FinalAssessmentService.getFinalAssessmentByStreamId(streamId)
      .then(({ data }) => {
        const assessmentData = [];
        filteredStudentsData.forEach((studentData) => {
          const assessmentItem = data.find(
            (item) => item.student.id === studentData.id
          );
          assessmentData.push({
            student: studentData.student,
            finalAssessment: assessmentItem ? assessmentItem.assessment : null,
          });
          setFinalAssessmentData(assessmentData);
          console.log(finalAssessmentData)
        });
      })
      .catch((e) =>
        notification.error({
          message: "Не удалось получить итоговые оценки",
          description: e.message,
        })
      )
      .finally(() => setLoading(false));
  };
  
  const openExamAssessmentModal = () => {
    setIsExamAssessmentModalOpen(true);
    setLoading(true);
    setExamAssessmentData([]);

    FinalAssessmentService.getExamAssessmentByStreamId(streamId)
      .then(({ data }) => {
        
        const assessmentData = [];
        filteredStudentsData.forEach((studentData) => {
          const assessmentItem = data.find(
            (item) => item.student.id === studentData.id

            
          );
          assessmentData.push({
            
            student: studentData.student,
            finalAssessment: assessmentItem ? assessmentItem.assessment : null,
            key: studentData.id,
            assessmentId: assessmentItem ? assessmentItem.id : null,
          });
          
          setExamAssessmentData(assessmentData);
        });
      })
      .catch((e) =>
        notification.error({
          message: "Не удалось получить итоговые оценки",
          description: e.message,
        })
      )
      .finally(() => setLoading(false));
  };

  const openFinalExamAssessmentModal = () => {
    setIsFinalExamAssessmentModalOpen(true);
    setLoading(true);
    setFinalExamAssessmentData([]);

    FinalAssessmentService.getFinalExamAssessmentByStreamId(streamId)
      .then(({ data }) => {
        
        const assessmentData = [];
        filteredStudentsData.forEach((studentData) => {
          const assessmentItem = data.find(
            (item) => item.student.id === studentData.id

            
          );
          assessmentData.push({
            
            student: studentData.student,
            finalAssessment: assessmentItem ? assessmentItem.assessment : null,
            key: studentData.id,
            assessmentId: assessmentItem ? assessmentItem.id : null,
          });
          
          setFinalExamAssessmentData(assessmentData);
        });
      })
      .catch((e) =>
        notification.error({
          message: "Не удалось получить итоговые оценки",
          description: e.message,
        })
      )
      .finally(() => setLoading(false));
  };
  const closeFinalAssessmentModal = () => {
    setCurrentFinalAssessmentStudent(null);
    setIsFinalAssessmentModalOpen(false);
  };
  const closeExamAssessmentModal = () => {
    // setCurrentFinalAssessmentStudent(null);
    setIsExamAssessmentModalOpen(false);
  };
  const closeFinalExamAssessmentModal = () => {
    // setCurrentFinalAssessmentStudent(null);
    setIsFinalExamAssessmentModalOpen(false);
  };

  const editFinalGrade = (record) => {
    console.log(currentFinalAssessmentStudent);
    setIsModalOpen(true);
    FinalAssessmentService.getFinalAssessmentByStudentIdAndStreamId(
      record.id,
      streamId
    )
      .then(({ data }) => {
        
        if (!data) {
          setCurrentFinalAssessmentStudent({
            studentId: record.id,
            studentName: record.student,
            currentGrade: null,
            assessmentId: null,
          });
          setHasGrade(false);
          return;
        }
        setCurrentFinalAssessmentStudent({
          studentId: record.id,
          studentName: record.student,
          currentGrade: data.assessment,
          assessmentId: data.id,
        });
        setHasGrade(true);
      })
      .catch((e) => {
        notification.error({
          message: "Произошла ошибка",
          description: e.message,
        });
      })
      .finally(() => {});
  };

  const getLessonsPromise = () => {
    return StreamService.getLessons(teacherId, streamId)
      .then(({ data }) => {
        updateOperationRow(
          columns,
          data,
          OperationRow(edit, editFinalGrade, save, cancel)
          // FinalGradeRow()
        );
        lessons.current = data;
      })
      .catch((err) => notification.error({ message: err }));
  };

  const getAssessmentsPromise = () => {
    return StreamService.getAssessmentsOfEachStudent(teacherId, streamId)
      .then(({ data }) => {
        studentsData.current = data;

        filterDataFromStudentDataToTable(data);
      })
      .catch((err) => notification.error({ message: err }));
  };

  useEffect(() => {
    setLoading(true);
    getLessonsPromise();
    FinalAssessmentService.getFinalAssessmentByStreamId(streamId)
      .then(({ data }) => console.log(data))
      .catch((e) => console.log(e.message));
    getAssessmentsPromise().finally(() => setLoading(false));
  }, []);

  //   const addLessonDateColumns = (columns, data) => {
  //     const newColumns = [...columns];
  //     data.forEach((item) => {
  //       newColumns.push({
  //         title: item.date,
  //         dataIndex: item.id,
  //         key: item.id,
  //         editable: true,
  //       });
  //     });
  //     newColumns.push(OperationRow(edit, save, cancel));
  //     setColumns(newColumns);
  //   };

  const filterDataFromStudentDataToTable = (students) => {
    let data = [];
    students.forEach((item) => {
      data.push({
        key: item.id,
        id: item.id,
        student: `${item.surname} ${item.name}`,
      });
    });

    data.forEach((item) => {
      lessons.current.forEach((lesson) => {
        item[lesson.id] = "";
      });
    });
    students.forEach((student) => {
      student.assessments.forEach((lesson) => {
        data.map((studentFromData) => {
          //проходимся по всему списку таблицы
          if (studentFromData.id === student.id) {
            studentFromData[lesson.lesson.id] = lesson.assessment;
          }
        });
      });
    });

    setFilteredStudentsData(data);
   
  };

  //addLessonDateColumns похож
  const updateOperationRow = (columns, data, OperationRow) => {
    let newColumns = [...columns];
    data.forEach((item) => {
      newColumns.push({
        title: item.date,
        dataIndex: item.id,
        key: item.id,
        editable: true,
      });
    });

    // newColumns.push(FinalGradeRow);
    newColumns.push(OperationRow);
    setColumns(newColumns);
  };

  const edit = (record) => {
    const currentRecord = record;
    let fieldValues = {};
    lessons.current.forEach((item) => {
      fieldValues[item.id] = "";
    });
    fieldValues = Object.assign(fieldValues, record);
    form.setFieldsValue(fieldValues);
    setEditingKey(record.key);
    updateOperationRow(
      columns,
      lessons.current,
      OperationRowOnEdit(edit, editFinalGrade, save, cancel, currentRecord)
      // FinalGradeRow()
    );
  };

  const cancel = () => {
    setEditingKey("");
    updateOperationRow(
      columns,
      lessons.current,
      OperationRow(edit, editFinalGrade, save, cancel)
      // FinalGradeRow()
    );
  };

  const findUpdatedGrades = (prevValues, newValues, record) => {
    const studentId = record.id;
    //сравниваем и сохраняем данные в массив обновленных оценок
    const updatedGradesRow = newValues.map((item, idx) => {
      if (prevValues[idx] !== item && prevValues[idx] !== "" && item !== null)
        return item;
    });
    const updatedGradesLessonIds = updatedGradesRow
      .map((item, idx) =>
        item || item === 0 || item === null ? idx : undefined
      )
      .filter((item) => item);

    const updatedGradesAssessmentIds = updatedGradesLessonIds
      .map((item) => {
        return studentsData.current.map((student) => {
          return student.assessments.find(
            (assessment) =>
              assessment.lesson.id === item && student.id === record.id
          );
        });
      })
      .map((item) => {
        return {
          ...item.filter((assessment) => assessment !== undefined),
        }[0];
      })
      .map((item) => item.id);

    let updatedGradesAssessments = [];
    updatedGradesLessonIds.forEach((lessonId) => {
      updatedGradesAssessments.push(updatedGradesRow[lessonId]);
    });
    let updatedGrades = [];
    updatedGradesLessonIds.forEach((item, idx) => {
      updatedGrades.push({
        id: updatedGradesAssessmentIds[idx],
        studentId: studentId,
        lessonId: item,
        assessment: updatedGradesAssessments[idx],
      });
    });
    return updatedGrades;
  };

  const findNewGrades = (prevValues, newValues, record) => {
    const studentId = record.id;
    //сравниваем и сохраняем данные в массив новые оценок
    const createdGradesRow = newValues.map((item, idx) => {
      if (prevValues[idx] !== item && prevValues[idx] === "") return item;
    });
    const createdGradesLessonIds = createdGradesRow
      .map((item, idx) => (item || item === 0 ? idx : undefined))
      .filter((item) => item);

    let createdGradesAssessments = [];
    createdGradesLessonIds.forEach((lessonId) =>
      createdGradesAssessments.push(createdGradesRow[lessonId])
    );

    let newGrades = [];
    createdGradesLessonIds.forEach((item, idx) => {
      newGrades.push({
        studentId: studentId,
        lessonId: item,
        assessment: createdGradesAssessments[idx],
      });
    });
    return newGrades;
  };

  const findDeletedGrades = (prevValues, newValues, record) => {
    const studentId = record.id;
    //сравниваем и сохраняем данные в массив обновленных оценок
    const deletedGradesRow = newValues.map((item, idx) => {
      if (prevValues[idx] !== item && item === null) return item;
    });
    const deletedGradesLessonIds = deletedGradesRow
      .map((item, idx) =>
        item || item === 0 || item === null ? idx : undefined
      )
      .filter((item) => item);

    const deletedGradesAssessmentIds = deletedGradesLessonIds
      .map((item) => {
        return studentsData.current.map((student) => {
          return student.assessments.find(
            (assessment) =>
              assessment.lesson.id === item && student.id === record.id
          );
        });
      })
      .map((item) => {
        return {
          ...item.filter((assessment) => assessment !== undefined),
        }[0];
      })
      .map((item) => item.id);
    // let deletedGradesAssessments = [];
    // deletedGradesLessonIds.forEach((lessonId) => {
    //   if (!deletedGradesRow[lessonId])
    //     deletedGradesAssessments.push(deletedGradesRow[lessonId]);
    // });

    const deletedGrades = [];
    deletedGradesLessonIds.forEach((item, idx) => {
      deletedGrades.push({
        id: deletedGradesAssessmentIds[idx],
      });
    });

    return deletedGrades;
  };

  const save = async (record) => {
    try {
      //достаем старые и новые значения
      let prevValues = [];
      prevValues = Object.assign(prevValues, record);

      const row = await form.validateFields();
      let newValues = [];
      newValues = Object.assign(newValues, row);

      const updatedGrades = findUpdatedGrades(prevValues, newValues, record);
      const deletedGrades = findDeletedGrades(prevValues, newValues, record);
      const newGrades = findNewGrades(prevValues, newValues, record);

      const updateData = [...updatedGrades, ...newGrades];
      const deleteData = [...deletedGrades];

      setLoading(true);

      if (updateData.length !== 0)
        StreamService.updateAssessmentsOfEachStudent(teacherId, updateData)
          .then(() => notification.success({ message: "Оценки изменены" }))
          .catch((err) => notification.error({ message: err }))
          .finally(() => {
            getLessonsPromise();
            getAssessmentsPromise().finally(() => setLoading(false));
          });

      if (deleteData.length !== 0)
        StreamService.deleteAssessmentsOfEachStudent(teacherId, deleteData)
          .then(() => notification.success({ message: "Оценки удалены" }))
          .catch((err) => notification.error({ message: err }))
          .finally(() => {
            getLessonsPromise();
            getAssessmentsPromise().finally(() => setLoading(false));
          });

      setEditingKey("");
      updateOperationRow(
        columns,
        lessons.current,
        OperationRow(edit, editFinalGrade, save, cancel)
        // FinalGradeRow()
      );
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const exportAssesmentsList = () => {
    return authAxios({
      url: `http://85.159.27.198:8080/abitur/api/v1/document/get-assessment-document?stream-id=${streamId}`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + TokenService.getLocalAccessToken(),
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `grades${streamId}.pdf`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "number",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return {
    filteredStudentsData,
    exportAssesmentsList,
    mergedColumns,
    isModalOpen,
    currentFinalAssessmentStudent,
    setCurrentFinalAssessmentStudent,
    openFinalAssessmentModal,
    handleChangeFinalAssessment,
    handleCancel,
    isFinalAssessmentModalOpen,
    isExamAssessmentModalOpen,
    isFinalExamAssessmentModalOpen,
    closeExamAssessmentModal,
    closeFinalAssessmentModal,
    closeFinalExamAssessmentModal,
    openExamAssessmentModal,
    openFinalExamAssessmentModal,
    finalAssessmentData,
    examAssessmentData,
    finalExamAssessmentData,
    loading,
    form,
  };
}
